import { h, render, Component } from 'preact';
import linkState from 'linkstate';
import axios from 'axios';
class AddNewUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: this.props.username || '',
            password: '',
            confirmPassword: '',
            role: this.props.role || 'user'
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.radioChange = this.radioChange.bind(this);
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.state.password !== this.state.confirmPassword) {
            alert('Passwords do not match');
            return;
        }
        const url = this.props.userId ? `/api/user/${this.props.userId}` : '/api/user';
        axios({
            url,
            method: this.props.method,
            headers: {
                Authorization: `Bearer ${this.props.auth.user.token}`
            },
            data: {
                username: this.state.username,
                password: this.state.password,
                role: this.state.role
            }
        })
            .then(({ data }) => {
            let type = this.props.method === "put" ? 'updated' : 'added';
            alert(`Successfully ${type} ${data.username}`);
            window.location.reload();
        })
            .catch(err => {
            console.log(err);
            alert(err);
        });
    }
    radioChange(e) {
        this.setState({ role: e.currentTarget.value });
    }
    render() {
        return (h("form", { onSubmit: this.handleSubmit },
            h("h1", null, "Add New User"),
            h("div", { className: "input__row" },
                h("label", { htmlFor: "username" }, "Username"),
                h("input", { name: "username", type: "text", onChange: linkState(this, 'username'), value: this.state.username, required: true, placeholder: "Username" })),
            h("div", { className: "input__row" },
                h("div", { className: "columns" },
                    h("div", { className: "mr--lrg invoice__type" },
                        h("label", { for: "admin", className: "mb--xs u-block" }, "Admin"),
                        h("input", { className: "input__radio", type: "radio", id: "admin", name: "role", value: "admin", onChange: this.radioChange, required: true })),
                    h("div", { className: "invoice__type" },
                        h("label", { for: "user", className: "mb--xs u-block" }, "User"),
                        h("input", { className: "input__radio", type: "radio", id: "user", name: "role", value: "user", onChange: this.radioChange, required: true })))),
            h("div", { className: "input__row" },
                h("label", { htmlFor: "password" }, "Password"),
                h("input", { name: "password", type: "password", onChange: linkState(this, 'password'), value: this.state.password, required: true, placeholder: "Password" })),
            h("div", { className: "input__row" },
                h("label", { htmlFor: "confirm-password" }, "Confirm Password"),
                h("input", { name: "confirm-password", type: "password", onChange: linkState(this, 'confirmPassword'), value: this.state.confirmPassword, placeholder: "Confirm Password", required: true })),
            h("div", { className: "input__row" },
                h("button", { type: "submit", className: "btn" }, "Submit"))));
    }
}
AddNewUser.defaultProps = {
    method: 'post'
};
export default AddNewUser;
